import { createFileRoute } from "@tanstack/react-router";

import { FeaturesPage } from "@/components/marketing/features-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/features")({
  head: () => pageHead("features"),
  component: FeaturesPage,
});
